import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    file: Object,
  },
  data() {
    return {
      faces: [],
      updatingFace: false,
      showFaces: false,
      addingFace: false,
    };
  },
  created() {
    this.faces = this.file.faces;

    EventBus.$on(`faces--delete`, (data) => {
      this.removeFaceFromFile(data.id);
    });
    EventBus.$on(`faces--update`, (data) => {
      this.updatingFace = data;
    });

    EventBus.$on("faces--add-face", (data) => {
      this.addFaceSubmit(data);
    });
  },
  methods: {
    removeFaceFromFile(id) {
      const formData = new FormData();

      if (this.updatingFace.id === id) {
        this.updatingFace = false;

        EventBus.$emit(`faces--cancel`);
      }

      formData.append("file", this.file.id);
      formData.append("myspace", this.file.mySpace);
      formData.append("face", id);

      this.$axios.post(baseUrl + "/facedelete", formData).then((r) => {
        this.faces = this.faces.filter((face) => {
          return face.id !== id;
        });

        EventBus.$emit(`faces-overlay--update-faces`, this.faces);
      });
    },
    toggleShowFaces() {
      this.showFaces = !this.showFaces;

      if (!this.showFaces) {
        //als hide add
        this.addingFace = false;
        EventBus.$emit(`faces-overlay--adding-face`, this.addingFace);
      }

      EventBus.$emit(`faces-overlay--${this.showFaces ? "show" : "hide"}`);
    },
    startAddingFace(e) {
      e.preventDefault();

      if (!this.updatingFace) {
        this.addingFace = !this.addingFace;

        this.showFaces = true;
        EventBus.$emit(`faces-overlay--${this.showFaces ? "show" : "hide"}`);

        EventBus.$emit(`faces-overlay--adding-face`, this.addingFace);
      } else {
        //remove updating tag
        this.updatingFace = false;

        EventBus.$emit(`faces--cancel`);
      }
    },
    addFace(e) {
      e.preventDefault();

      EventBus.$emit(`faces-overlay--add-face`);
    },
    addFaceSubmit(data) {
      this.addingFace = false;

      EventBus.$emit(`faces-overlay--adding-face`, this.addingFace);

      //get form data
      const formData = new FormData(this.$refs.updateFace);

      formData.append("file_id", this.file.id);
      formData.append(
        "face",
        JSON.stringify({ ...data, name: formData.get("facename") })
      );

      this.$axios.post(baseUrl + "/facemanual", formData).then((r) => {
        this.faces = r.data.faces;
        EventBus.$emit(`faces-overlay--update-faces`, this.faces);
      });
    },
    updateFace(e) {
      e.preventDefault();

      //get form data
      const formData = new FormData(this.$refs.updateFace);

      //add tag
      this.updatingFace = false;

      formData.append("file", this.file.id);
      formData.append("myspace", this.file.mySpace);

      this.$axios.post(baseUrl + "/faceadd", formData).then((r) => {
        this.faces = this.faces.map((face) => {
          if (face.id === formData.get("id")) {
            return {
              ...face,
              name: formData.get("facename"),
            };
          }

          return face;
        });

        EventBus.$emit(`faces-overlay--update-faces`, this.faces);

        this.showFaces = true;
      });
    },
  },
};
